var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('b-container',[_c('h4',{staticClass:"mt-2"},[_vm._v("Success")]),_c('p',[_vm._v("You have been unsubscribed !")]),_c('p',[_vm._v("Have a nice day")])]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }